import type { CloneStatus, Health, Severity } from '@api/api';

/** Reserved status colours (never reused as series colours). */
export const HEALTH_COLOR: Record<Health, string> = {
  ok: '#1e9e5a',
  degraded: '#e08a00',
  down: '#d93636',
  unknown: '#8a8f98',
  stopped: '#8a8f98',
  provisioning: '#2a78d6',
};

export const HEALTH_LABEL: Record<Health, string> = {
  ok: 'OK',
  degraded: 'Degraded',
  down: 'Down',
  unknown: 'Unknown',
  stopped: 'Stopped',
  provisioning: 'Provisioning',
};

export const HEALTH_ORDER: Record<Health, number> = {
  down: 0,
  degraded: 1,
  unknown: 2,
  provisioning: 3,
  stopped: 4,
  ok: 5,
};

export const STATUS_LABEL: Record<CloneStatus, string> = {
  draft: 'Draft',
  provisioning: 'Provisioning',
  running: 'Running',
  stopped: 'Stopped',
  failed: 'Failed',
  deleting: 'Deleting',
  deleted: 'Deleted',
};

export type MuiColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

export const STATUS_CHIP: Record<CloneStatus, MuiColor> = {
  draft: 'default',
  provisioning: 'info',
  running: 'success',
  stopped: 'default',
  failed: 'error',
  deleting: 'warning',
  deleted: 'default',
};

export const SEVERITY_CHIP: Record<Severity, MuiColor> = {
  critical: 'error',
  warning: 'warning',
  info: 'info',
};

export const JOB_CHIP: Record<string, MuiColor> = {
  queued: 'default',
  running: 'info',
  succeeded: 'success',
  failed: 'error',
};
